import React from "react";
import styled from "styled-components";
import {
  color as c,
  ColorProps,
  space,
  SpaceProps,
  typography,
  TypographyProps,
  LayoutProps,
  layout
} from "styled-system";
import WithEventTracker from "../../WithEventTracker";

interface Props {
  href: string;
  target?: "_blank";
  color?: string;
  children: React.ReactNode;
}

const Href = styled.a`
  ${c}
  ${layout}
  ${typography}
  ${space}
  text-decoration: none;
  cursor: pointer;
`;


const Link: React.FC<Props & LayoutProps & ColorProps & TypographyProps & SpaceProps> = ({
  href,
  target,
  children,
  ...props
}) => (
  <Href href={href} target={target} {...props} rel="noopener">
    {children}
  </Href>
);

export default WithEventTracker(Link);
